import { render, staticRenderFns } from "./geo.vue?vue&type=template&id=72865c78&scoped=true"
import script from "./geo.vue?vue&type=script&lang=js"
export * from "./geo.vue?vue&type=script&lang=js"
import style0 from "./geo.vue?vue&type=style&index=0&id=72865c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72865c78",
  null
  
)

export default component.exports